import debounce from 'lodash.debounce';

import LoggingUtil from './logging-util';

interface DebounceOptions {
  delay: number;
  leading?: boolean;
  maxWait?: number;
}

class EventsUtil {
  private events: readonly string[];
  private handler: EventListener;

  constructor(
    events: readonly string[],
    handler: EventListener,
    private logger: LoggingUtil,
    debounceOptions?: DebounceOptions,
  ) {
    this.logger = logger;
    this.events = events;

    const handlerWithLogging = (event: Event) => {
      this.logger.log('debug', `Event ${event.type} detected.`);
      handler(event);
    };

    if (debounceOptions) {
      const { delay, leading, maxWait } = debounceOptions;
      this.handler = debounce(handlerWithLogging, delay, { leading, maxWait });
      this.logger.log(
        'debug',
        `Debounce'd handler with delay=${delay}, leading=${leading}, maxWait=${maxWait}.`,
      );
    } else {
      this.handler = handlerWithLogging;
    }
  }

  bind(): void {
    this.events.forEach((event) => {
      window.addEventListener(event, this.handler);
      this.logger.log('debug', `Added listener for ${event}.`);
    });
  }

  unbind(): void {
    this.events.forEach((event) => {
      window.removeEventListener(event, this.handler);
      this.logger.log('debug', `Removed listener for ${event}.`);
    });
  }
}

export default EventsUtil;
